import {Injectable} from '@angular/core';
import {FileAttachment} from '../model/file-attachment.model';
import {FileApi} from '../api/file.api';
@Injectable()
export class FileService {

    constructor(private fileApi: FileApi) {}

    getFile = (guid: string) => this.fileApi.getFile(guid);

    getFileBlob = (guid: string) => this.fileApi.getFileBlob(guid);

    getFileResponse = (guid: string) => this.fileApi.getFileResponse(guid);

    getFilesForItem = (type: number, typeId: string) => this.fileApi.getFilesForItem(type, typeId);

    uploadFile = ({ fileList, type, typeId, portalId, fileId, displayName } :
        { fileList: FileList, type: number, typeId: string, portalId: number, fileId?: string, displayName?:string }) =>
        this.fileApi.uploadFile({ fileList, type, typeId, portalId, fileId, displayName });

    uploadSignature = (
        { signature, type, typeId, subTypeId, portalId, fileId } :
        { signature: Blob, type: number, typeId: string, subTypeId: number, portalId: number, fileId?: string }) => 
        this.fileApi.uploadSignature({ signature, type, typeId, subTypeId, portalId, fileId });

    deleteFile = (file: FileAttachment) => this.fileApi.deleteFile(file);

    dataURItoBlob(dataURI) {
        let byteString: string = atob(dataURI.split(',')[1]);
        let mimeString: string = dataURI.split(',')[0].split(':')[1].split(';')[0];

        let ab: ArrayBuffer = new ArrayBuffer(byteString.length);
        let ia: Uint8Array = new Uint8Array(ab);
        for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }

        return new Blob([ab], { type: mimeString });
    }
}